import React, { useState } from 'react'
import {
  Tooltip,
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core'
import Chip from '@material-ui/core/Chip'
import ErrorIcon from '@material-ui/icons/ErrorOutline'

const useStyles = makeStyles((theme) => ({
  invalidBadge: {
    backgroundColor: '#FFE3E3',
    color: theme.palette.error.main,
    fontSize: '10px',
    height: '24px',
    fontWeight: 600,
    border: `0.5px solid ${theme.palette.error.main}`,
    marginLeft: theme.spacing(0.25),
    '& .MuiChip-icon': {
      color: theme.palette.error.main,
      fontSize: '16px',
    },
  },
  tooltip: {
    backgroundColor: '#F6F6F6',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    borderRadius: '16px',
    padding: 0,
    maxWidth: '400px',
    border: `2px solid ${theme.palette.error.main}`,
  },
  arrow: {
    color: theme.palette.error.main,
    '&::before': {
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    },
  },
  tooltipContent: {
    padding: theme.spacing(2),
  },
  referenceText: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.error.main,
    fontWeight: 400,
  },
}))

const InvalidCepBadge = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const tooltipContent = (
    <Box className={classes.tooltipContent}>
      <Typography className={classes.referenceText}>
        O CEP informado é inválido, isso pode impedir que sua cotação
        seja emitida de forma automática.
      </Typography>
    </Box>
  )

  return (
    <Tooltip
      title={tooltipContent}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      placement="top"
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      interactive
      enterDelay={200}
      leaveDelay={200}
    >
      <span
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <Chip
          icon={<ErrorIcon />}
          label="CEP inválido"
          className={classes.invalidBadge}
          size="small"
        />
      </span>
    </Tooltip>
  )
}

export default InvalidCepBadge
